<template>
  <div class="top-right-btn">
    <el-row>
      <el-tooltip
        class="item"
        effect="dark"
        :content="
          showSearch ? $t('common.hiddenSearch') : $t('common.showSearch')
        "
        placement="top"
      >
        <el-button
          size="mini"
          circle
          icon="el-icon-search"
          @click="toggleSearch()"
        />
      </el-tooltip>
      <!-- <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <el-button size="mini" circle icon="el-icon-refresh" @click="refresh()" />
      </el-tooltip> -->
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('common.showCol')"
        placement="top"
        v-if="columnsVal"
      >
        <el-button
          size="mini"
          circle
          icon="el-icon-menu"
          @click="showColumn()"
        />
      </el-tooltip>
    </el-row>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="700px">
      <el-transfer
        :titles="[$t('common.show'), $t('common.hidden')]"
        v-model="value"
        :data="columnsVal"
        style="margin: auto;"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "RightToolbar",
  data() {
    return {
      columnsVal:this.columns,
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false
    };
  },
  props: {
    showSearch: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array
    }
  },
  created() {
    this.init();
  },
  methods: {
    init(val) {
      if (!this.columnsVal) {
        if (val) {
          this.columnsVal = val;
        } else {
          return;
        }
      }
      // 显隐列初始默认隐藏列
      for (let item in this.columnsVal) {
        if (this.columnsVal[item].visible === false) {
          this.value.push(parseInt(item));
        }
      }
    },
    // 搜索
    toggleSearch() {
      this.$emit("update:showSearch", !this.showSearch);
    },
    // // 刷新
    refresh(val) {
      this.columnsVal = val;
      this.init(val);
    },
    // 右侧列表元素变化
    dataChange(data) {
      if (!this.columnsVal) {
        return;
      }
      for (let item in this.columnsVal) {
        const key = this.columnsVal[item].key;
        this.columnsVal[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-transfer__button {
  border-radius: 50%;
  padding: 12px;
  display: block;
  margin-left: 0px;
}
::v-deep .el-transfer__button:first-child {
  margin-bottom: 10px;
}
>>> .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/RightToolbar/index.vue